import React, { useMemo } from 'react';
import DataTable from './DataTableFigma';

//AcceleratedDataTable will hold the DataTable in memory without rerendering
//except when rerender props is true. In this case it works as a regular DataTable.
//hiddenColumns is in the memo deps so toggling column visibility re-renders the table.

const AcceleratedDataTable = (props) => {
  const content = (
    <DataTable
      itemList={props.itemList}
      orderBy={props.orderBy}
      orderDirection={props.orderDirection}
      changeOrderBy={props.changeOrderBy}
      type={props.type}
      getItemTypeFunction={props.getItemTypeFunction}
      selected={props.selected}
      selectable={props.selectable}
      thereIsNoSuchRowMessage={props.thereIsNoSuchRowMessage}
      popupEnabled={props.popupEnabled}
      redirectLinkOnInfo={props.redirectLinkOnInfo}
      ModalFeature={props.ModalFeature}
      afterClickOnCancel={props.afterClickOnCancel}
      hiddenColumns={props.hiddenColumns}
    />
  );
  if (props.rerender) return content;

  return useMemo(() => {
    return content;
  }, [props.hiddenColumns]);
};

export default AcceleratedDataTable;
